import { render, staticRenderFns } from "./Etiqueta.vue?vue&type=template&id=71a6754c&"
import script from "./Etiqueta.vue?vue&type=script&lang=js&"
export * from "./Etiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports